import $ from 'jquery';

/**
 * Custom Scripts
 */
import Form from './custom/forms';
// import SocialMedia from './custom/bjzm-social-feeds';
import BjzmScripts from './custom/bjzm-scripts';
import Slider from './custom/bjzm-slideshow.js';

import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
import HeaderScroll from './custom/header-scroll';
import SinglePageUpdown from './custom/single-page-updown';
import BjzmFormScripts from './custom/bjzm-form-scripts';
// import AppWebApiUtilities from './custom/app-web-api-utilities';

/**
 * Vendors
 */
import matchHeight from './vendors/jquery.matchHeight';
import magnificPopup from 'magnific-popup';


jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var RegisterFormScripts = new BjzmFormScripts();
 	// var WebApiUtilities = AppWebApiUtilities();

	/* Load More Posts */
	var LoadMorePosts = new BjzmLoadMorePosts({
		query_vars: BJZM_DATA.query_vars,
		ajax_url: BJZM_DATA.ajaxurl,
		max_num_pages: BJZM_DATA.max_num_pages,
		post_loop: $(".bjzm-wrapper__row--blog-posts"),
		template_partial: 'content-full-width-article'
	});

	var offset = $(window).outerWidth() < 767 ? 65 : 100;

	var heroScroll = new SinglePageUpdown({
		container: $(".scroll__outer"),
		offset: offset,
		changeHash: false
	});

	/* Homepage Slideshow*/
	var HomeSlider = new Slider("home_slider", {
		dots: true,
		customPaging : function(slider, i) {
 			return '<a href="#" class="slider__dots"></a>';
 		}
 	});


	/* Header Scroll */
	var MainHeaderScroll = new HeaderScroll({
		header: $(".header--collapse"),
		threshold: 200,
		class: 'header--collapsed'
	});
	

	/*privacy policy*/
	$('.lightbox').magnificPopup({
 		type: 'inline',
		midClick: true,
		removalDelay: 300,
		mainClass: 'mfp-fade mfp-wrap--privacy-policy'
	});


	$(".show-hero").change(function(){
		$(".home-wrapper").toggleClass('hero-map');
	});

	if( $(window).outerWidth() < 767 ) {
		var height = $(window).height();
		var newHeight = height - 195;
		// $(".hero, .hero__image").css('min-height', newHeight);
	}

});









